import React from 'react';

function Pagination({ currentPage, totalPages, onPageChange, baseUrl = '?' }) {
  if (totalPages <= 1) return null;

  const handleClick = (e, page) => {
    e.preventDefault();
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      window.scrollTo({ top: 0 });
      onPageChange(page);
    }
  };

  const getPageUrl = (page) => `${baseUrl}page=${page}`;

  const handlePageSelect = (e) => {
    e.preventDefault();
    const page = parseInt(e.target.value);
    if (page !== currentPage && page >= 1 && page <= totalPages) {
      window.scrollTo({ top: 0 });
      onPageChange(page);
    }
  };

  return (
    <nav
      className="flex items-center justify-between mt-8 md:mt-16"
      aria-label="Search results pagination"
    >
      <a
        href={currentPage > 1 ? getPageUrl(currentPage - 1) : '#'}
        className={`flex items-center justify-center gap-3 min-w-11 min-h-11 text-black text-sm [&[aria-disabled=true]]:opacity-40`}
        aria-label="Previous page"
        aria-disabled={currentPage === 1}
        tabIndex={currentPage === 1 ? -1 : 0}
        onClick={(e) => handleClick(e, currentPage - 1)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7"
          height="10"
          viewBox="0 0 7 10"
          fill="none"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M7 1.175L2.67341 5L7 8.825L5.66802 10L0 5L5.66802 0L7 1.175Z"
            fill="currentColor"
          />
        </svg>
        <span className="hidden md:block">Previous</span>
      </a>

      <div className="flex gap-4 items-center text-[#6B7280] text-sm">
        <label htmlFor="paginationPage">Page</label>

        <div className="relative">
          <select
            value={currentPage}
            onChange={handlePageSelect}
            aria-label="Select page number"
            className="text-base w-17 h-[42px] px-4 text-black appearance-none border border-[#EBEBEB] rounded bg-white"
            id="paginationPage"
          >
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <option key={page} value={page}>
                {page}
              </option>
            ))}
          </select>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="7"
            viewBox="0 0 10 7"
            fill="none"
            aria-hidden="true"
            focusable="false"
            className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
          >
            <use href="#icon-chevron-down" />
          </svg>
        </div>

        <span>of {totalPages}</span>
      </div>

      <a
        href={currentPage < totalPages ? getPageUrl(currentPage + 1) : '#'}
        className={`flex items-center justify-center gap-3 min-w-11 min-h-11 text-black text-sm [&[aria-disabled=true]]:opacity-40`}
        aria-label="Next page"
        aria-disabled={currentPage === totalPages}
        tabIndex={currentPage === totalPages ? -1 : 0}
        onClick={(e) => handleClick(e, currentPage + 1)}
      >
        <span className="hidden md:block">Next</span>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7"
          height="10"
          viewBox="0 0 7 10"
          fill="none"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M0 1.175L4.32659 5L0 8.825L1.33198 10L7 5L1.33198 0L0 1.175Z"
            fill="currentColor"
          />
        </svg>
      </a>
    </nav>
  );
}
export default Pagination;
